import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { HeaderStyle } from "../Common/styles/header";
import ParticipantList from "./ParticipantsList";
import AiSearch from "../Layout/AiSearch/AiSearch";
import { DownloadIcon, UploadV2Icon } from "../Common/assets/Icons";
import { ChangeEvent, useMemo, useState } from "react";
import { errorToastMessage, toastMessage } from "../../utils/toast";
import http from "../../utils/http";
import { useAppSelector } from "../../Redux/hooks";

const Participants = () => {
  const [toggle, setToggle] = useState(true);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [exportLoader, setExportLoader] = useState(false);
  const filters = useAppSelector((state) => state.aiSearch.filters);
  const currentSearchId = useAppSelector(
    (state) => state.aiSearch.currentSearchId
  );

  const refresh = () => {
    setToggle(!toggle);
  };

  const uploadCSV = async (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        toastMessage("warning", "File size must smaller than 5MB!");
        return false;
      }
      try {
        setSubmitLoader(true);
        const formData = new FormData();
        formData.append("file", file);
        let res = await http.post(
          `/platform/participants/bulk-upload`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        toastMessage("success", res?.data?.message);
        refresh();
      } catch (err) {
        errorToastMessage(err as Error);
      } finally {
        setSubmitLoader(false);
      }
    }
  };

  const exportParticipants = async () => {
    try {
      setExportLoader(true);
      let httpUrl = `/platform/participants/export?`;

      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          httpUrl += `&${key}=${value}`;
        }
      });

      const res = await http.get(httpUrl, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = `platform-participants-${new Date().getTime()}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      errorToastMessage(err as Error);
    } finally {
      setExportLoader(false);
    }
  };

  const hasFilter = useMemo(() => {
    return Object.values(filters).some((value) => value !== "");
  }, [filters]);

  return (
    <>
      <Box
        sx={{
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        <Box sx={{ ml: "auto" }}>
          <AiSearch />
        </Box>
      </Box>
      <Box sx={HeaderStyle}>
        <Typography fontWeight="medium" color="text.primary">
          Participants
        </Typography>
        <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
          {hasFilter && (
            <Button variant="outlined" component="label" sx={{ mr: 2 }}>
              Send to Study
            </Button>
          )}
          <Box sx={{ mr: 2 }}>
            {!currentSearchId &&
              (exportLoader ? (
                <CircularProgress size={25} />
              ) : (
                <Button
                  startIcon={<DownloadIcon />}
                  variant="outlined"
                  component="label"
                  onClick={exportParticipants}
                >
                  Export Participants
                </Button>
              ))}
          </Box>
          {submitLoader ? (
            <CircularProgress size={25} />
          ) : (
            <Button
              startIcon={<UploadV2Icon />}
              variant="outlined"
              component="label"
              // sx={{ height: "54px" }}
            >
              <span>Import Participants</span>
              <input
                hidden
                accept="text/csv"
                type="file"
                onChange={uploadCSV}
              />
            </Button>
          )}
        </Box>
      </Box>
      <Box sx={{ p: 3, height: "calc(100vh - 132px)", overflow: "auto" }}>
        <ParticipantList toggle={toggle} />
      </Box>
    </>
  );
};

export default Participants;
